/**
 * @file Breeze base class for insight
 * @author Heino Lenting
 */
import * as tslib_1 from "tslib";
import { EventEmitter } from '@angular/core';
import { InsightBase } from './insight-base';
import * as moment from 'moment';
import { BreezeService } from '../../core/breeze.service';
import { ResourceService } from '../../resource.service';
import { InsightProvider } from '../insight-provider';
import { InsightService } from '../insight.service';
import { LocalisationService } from '../../core/localisation.service';
import { AlertsService } from '../../core/alerts.service';
import { EventsService } from '../../core/event.service';
/**
 * Breeze class for an insight component.
 */
var InsightBreeze = /** @class */ (function (_super) {
    tslib_1.__extends(InsightBreeze, _super);
    /**
     * Constructs a BaseInsight.
     * @param configurationsService A service that manages the configuration for components.
     * @param provider A provider that contains extra information such as configuration data.
     */
    function InsightBreeze(resourceService, provider, insightService, localisationService, alertsService, eventsService) {
        var _this = _super.call(this, resourceService, provider, insightService, localisationService, alertsService) || this;
        _this.eventsService = eventsService;
        _this.sorting = [];
        _this.queryOptions = {};
        _this.entityName = undefined;
        _this.sourceName = undefined;
        _this.dynamicParameters = [];
        _this.loadedItems = [];
        /** Event triggered when a new data set is retrieved from the backend api. */
        _this.onRefresh = new EventEmitter();
        return _this;
    }
    /**
     * Refreshed the insight
     * @returns {Observable<QueryResult>} The result set from the backend.
     */
    InsightBreeze.prototype.refresh = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _a, result, error_1;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!this.entityType) {
                            return [2 /*return*/, null];
                        }
                        _a = this;
                        return [4 /*yield*/, this.insightService.getPublishedTill()];
                    case 1:
                        _a.publishedTill = _b.sent();
                        BreezeService.setDynamicParams(this.queryOptions, this.dynamicParameters, this);
                        _b.label = 2;
                    case 2:
                        _b.trys.push([2, 4, , 5]);
                        return [4 /*yield*/, this.insightService.getDataSet(this, this.loadedItems)];
                    case 3:
                        result = _b.sent();
                        this.afterItemsLoaded();
                        this.onRefresh.emit(result);
                        return [3 /*break*/, 5];
                    case 4:
                        error_1 = _b.sent();
                        console.log('Insight error: ' + error_1);
                        this.setState('error');
                        return [3 /*break*/, 5];
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    Object.defineProperty(InsightBreeze.prototype, "start", {
        /** The start for the insight based on configuration and today. */
        get: function () {
            var offset = 0;
            // Get the offset from the configuration
            if (this.configuration && this.configuration.data && this.configuration.data.startTimeOffset) {
                offset = this.configuration.data.startTimeOffset;
            }
            var start = moment().startOf('day');
            start.add(offset, 'day');
            return start.toDate();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(InsightBreeze.prototype, "finish", {
        /** The finish for the insight based on configuration and today. */
        get: function () {
            var offset = 0;
            // Get the offset from the configuration
            if (this.configuration && this.configuration.data && this.configuration.data.endTimeOffset) {
                offset = this.configuration.data.endTimeOffset;
            }
            var date = moment().endOf('day');
            date.add(offset, 'day');
            var finish = date.toDate();
            if (finish > this.publishedTill) {
                finish = this.publishedTill;
            }
            return finish;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Is called after the configuration is loaded.
     */
    InsightBreeze.prototype.afterInitialize = function () {
        var _this = this;
        _super.prototype.afterInitialize.call(this);
        // Get the insights settings
        if (this.configuration.data.dataSource) {
            this.sourceName = this.configuration.data.dataSource;
            this.entityName = this.configuration.data.entityName;
            var parameters = this.configuration.data.parameters;
            if (parameters) {
                this.queryOptions.parameters = Object.assign({}, parameters);
            }
            BreezeService.getDynamicParams(this.queryOptions, this.dynamicParameters);
            this.entityType = this.insightService.getEntityType(this.entityName);
            this.refresh();
        }
        this.subscriptionPool.add(this.eventsService.register('grid-refresh').subscribe(function () {
            _this.refresh();
        }));
    };
    /** Handle for the after items loaded event */
    InsightBreeze.prototype.afterItemsLoaded = function () {
        console.warn('The insight does not have a process result handler');
        this.setState('error');
    };
    return InsightBreeze;
}(InsightBase));
export { InsightBreeze };
